module.exports = __webpack_public_path__ + "img/w27.4b4fa7aa.svg";